import { lazy } from 'react';

const RegisterActorsPageConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: true,
					style: 'static'
				},
			}
		}
		
	},
	routes: [
		{
			path: '/integrative/config/new-actor',
			component: lazy(() => import('./RegisterPage'))
		}
	]
};

export default RegisterActorsPageConfig;
